import ValidatePhoneInput from "./intl-phone-input";
import {PhoneInputValue, SelectedPhoneCountry} from "./intl-phone-input";
import {GetSlugAndParamsFromNext, GenerateThreeNonZeroRandoms} from './utilities'

// Search gmail : https://mail.google.com/mail/u/sikabyte@gmail.com/#search/currencyapi

let signupForm = document.getElementById('signup')
let signupFormActionUrl, signupType, signupUrl, isPartnersSignup
// let gender


// If not signup page, then don't validate.
// Though functions will still be accessible since they are hoisted to the top
// See: https://stackoverflow.com/a/11035042/16649244
// https://stackoverflow.com/questions/11034997/how-can-i-conditionally-define-a-function-in-javascript
if (signupForm !== null ){ // Then it's a signup page

    // Globally set FullName
    window.TFullName = "";

    // Globally set userEmail
    window.TEmailAddress = "";

    // Globally set TrackLeadEvent
    window.TrackedLeadEvent = false


    signupFormActionUrl = signupForm.action
    // signupType = (signupFormActionUrl.includes("partner") || 
    // signupFormActionUrl.includes("promoter") ) ? "advanced" : "simple"
    let signupTypeObj = document.getElementById("signup-type")
    if (signupTypeObj == null){
        signupType = "unknonwn"
    }else {
        signupType = signupTypeObj.textContent.trim()
    }
    console.log("signuptype is", signupType)

    // If it's advanced signup type for partners, we need valid access code   
    // if url matches partners, then validate
    
    let accessCodeElem = document.getElementById("access-code");

    signupUrl = window.location.href;
    isPartnersSignup = (signupUrl.includes("partner"));
    if (isPartnersSignup) {        
        // Get query string and set the access-code
        const queryParams = getQueryParams(window.location.href); 
        // Assuming the URL is https://example.com/?name=John&age=30
        // console.log(queryParams.name); // Output: John
        // console.log(queryParams.age); // Output: 30
        let accessCode = queryParams.access_code
        if ( accessCode == "undefined") {
            accessCode = ""
        }
        if (accessCodeElem !== null) {
            accessCodeElem.value = accessCode;
        }
    }


    let desiredGenderElem = document.getElementById("desired-gender-select") 
    let desiredGender = "male"
    
    let genderElem = document.getElementById("gender")     
    let secretCodeElem = document.getElementById("secret-code") 
    let currencyElem = document.getElementById("currency-select")
    
    // We need this to show error when any password field is empty on form submit
    let validatingPasswordOnFormSubmit = false // Not currently validating password on Form Submit
    

    // Fires immediately all deffered scripts are loaded and executed.
    // Dom is readym but resources like images and iframes may not be loaded yet.
    // You can use window.addEventListener('load' instead
    document.addEventListener("DOMContentLoaded", (_) => {
        let signupMethodSelect = document.getElementById('signup-method-select')
        if (signupMethodSelect !== null){
            signupMethodSelect.addEventListener("change", (e) => {
                console.log(e.target.value);
                var value = e.target.value;
                var text = e.target.options[e.target.selectedIndex].text;  
    
                let signupFormContainer = document.getElementById("signup-form-container")
                let emailContainer = document.getElementById("email-container")            
                let phoneContainer = document.getElementById("phone-container")
                
                let targetEmailInput = document.getElementById("email")            
                let targetPhoneInput = document.getElementById("phone")

                let targetFocusInput = null;
                
                if (value == "email") {
                    //Unhide email email
                    emailContainer.classList.remove("hidden")
                    targetFocusInput = targetEmailInput;
                  
                } else {
                    // Unhide phone container
                    phoneContainer.classList.remove("hidden")
                    targetFocusInput = targetPhoneInput;
      
                }

                // Send tracking event
                SubmitTrackedAuthEventInfo("signup_method_selected: " + value, "signup")
                

                // Unhide signup-form and 
                signupFormContainer.classList.remove("hidden")

                // Focus either email or phone depending on user's choice
                 // Focus First Input
                // const targetFullNameInput = document.getElementById('fullname');
                if (targetFocusInput) {
                    targetFocusInput.scrollIntoView({ behavior: 'smooth' });
                    targetFocusInput.setAttribute('tabindex', '-1'); // ensure it can receive focus
                    targetFocusInput.focus({ preventScroll: true });
                }  

                // Send tracking event
                SubmitTrackedAuthEventInfo("signup_container_step_one_revealed_and_focused", "signup")          
    
            });
        }


        // Button to show next section of form
        let signupStepTwoBtn = document.getElementById('signup-show-step-two-button')
        let signupStepTwoContainer = document.getElementById('signup-flow-step-two-container')
        
        if (signupStepTwoBtn !== null){
            signupStepTwoBtn.addEventListener("click", (e) => {

                 // Send tracking event
                SubmitTrackedAuthEventInfo("signup_show_step_two_btn_clicked: ", "signup")

                // Unhide signup step two container 
                signupStepTwoContainer.classList.remove("hidden")

                // Hide signup step two button (TODO: Are we leaking memory here? should we removeEventListener before hiding element?)
                signupStepTwoBtn.classList.add("hidden")

                // Focus Next Input
                const targetUsername = document.getElementById('username');
                if (targetUsername) {
                targetUsername.scrollIntoView({ behavior: 'smooth' });
                targetUsername.setAttribute('tabindex', '-1'); // ensure it can receive focus
                targetUsername.focus({ preventScroll: true });
                } 

                // Send tracking event
                SubmitTrackedAuthEventInfo("signup_container_step_two_revealed_and_focused", "signup")   
            }) 
        }

        // Let's know when user enters fullname
        let fullnameInput = document.getElementById('fullname')
        
         if (fullnameInput !== null){
            fullnameInput.addEventListener("change", (e) => {
                console.log(e.target.value);
                var value = e.target.value; 

                window.TFullName = value;

                // Send tracking event
                SubmitTrackedLeadEvent("user_fullname_entered: " + value, "signup")

            });


            // With enter Key, click on show step two button (If no enter, then click will hide button. It won't be enter and click)
             fullnameInput.addEventListener("keydown", function (event) {
                if (event.key === "Enter") {
                    event.preventDefault(); // Prevent form submission if inside a form
                    signupStepTwoBtn.click(); // Simulate button click
                }
            });
            
        }

        // Tracked phone input intl-phone-input module


        // Let's know when user enters email
        let userEmail = document.getElementById('email');

        if (userEmail !== null){
            userEmail.addEventListener("change", (e) => {
                console.log(e.target.value);
                var value = e.target.value; 

                window.TEmailAddress = value;

                // Send tracking event
                SubmitTrackedLeadEvent("user_email_entered: " + value, "signup")

            });
            
        }

    });

    signupForm.addEventListener('submit', function(event) {

        // Disable signup button


        event.preventDefault(); // Prevent the form from submitting
        let isValidated = true


        //Validate Desired Gender
        let validDesiredGenderInput = validateDesiredGenderInput()
        if (!validDesiredGenderInput){
            console.log("desired gender not selected");
            isValidated = false
            return false
        } 

        //Validate User's Gender
        let validUserGenderInput = validateGenderInput()
        if (!validUserGenderInput){
            console.log("user's gender not selected");
            isValidated = false
            return false
        } 

        //Validate Partner's Access Code
        let validPartnerAccessCodeInput = validatePartnersAccesCode()
        if (!validPartnerAccessCodeInput){
            console.log("access code did not pass validation");
            isValidated = false
            return false
        } 

        //Validate Secret Code
        let validSecretCodeInput = validateSecretCodeInput()
        if (!validSecretCodeInput){
            console.log("secret code did not pass validation");
            isValidated = false
            return false
        } 

        //Validate Currency Input
        let validCurrencySelectInput = validateCurrencySelectInput()
        if (!validCurrencySelectInput){
            console.log("currency input did not pass validation");
            isValidated = false
            return false
        } 

        // Call intlInput exported method to validate phone
        // empty phone inputs returns true
        let validatePhoneInput = ValidatePhoneInput()
        if (!validatePhoneInput){
            console.log("invalid phone number");
            // For the sake of some kind of devices where the phone numbers even when valid are showing invalid, we just let them signup.
            // As long as phone input is not empty
            let phoneInputValue = document.querySelector("#phone").value;
            if (!(phoneInputValue == "" || phoneInputValue == " ") && phoneInputValue.length > 6){
                isValidated = true
                return true
            }

            // Send tracking event
            SubmitTrackedAuthEventInfo("has_not_passed_user_phone, country: " + SelectedPhoneCountry + " " + phoneInputValue, "signup")

            isValidated = false
            return false

        }

        let isUniqueEmail = ValidateEmailUnique()
        if(!isUniqueEmail){
            isValidated = false
            console.log("email is not unique")
            return false
        }
        
        // Email and Phone Number cannot be empty
        // This check is required since email and phone are optional fields
        // But one must be provided
        let emailValue = document.getElementById('email').value;
        let phoneValue = document.querySelector("#phone").value;
        if ((emailValue == "" && phoneValue == "")) {
            console.log("Email and Phone Number cannot be empty")
            alert("Provide either Email or Phone number.")
            return false
        }

        // Set the customer's country
        const countryInput = document.getElementById('country');
        // Maybe export a getter for this in the intlInput package
        countryInput.value = SelectedPhoneCountry;
        console.log("Selected country is", SelectedPhoneCountry)

        // Trim Fullname
        const fullnameInput = document.getElementById('fullname')
        fullnameInput.value = fullnameInput.value.trim()

        // // Parse Gender Input
        // const genderInput = document.getElementById('gender')
        // gender = Number()

        // Validate Username
        let isUniqueUsername = ValidateUsernameUnique()
        if(!isUniqueUsername){
            isValidated = false
            console.log("Username is not unique")
            return false
        }

    
        // Username will be validated in isUsernameUnique()
        validatingPasswordOnFormSubmit = true    
        let isValidPassword = ValidatePasswords()
        if (!isValidPassword){
            isValidated = false
            console.log("Invalid Password")
            // Return it to false
            validatingPasswordOnFormSubmit = false
            return false
        }
     
        // Submit the form manually
        if (isValidated) {
            resetPasswordCheckNotices()
            SubmitSignUpForm()
        }

        return isValidated
    });

    // Add listener for formdata event
    // You can change the form values here
    // For advanced form submission with formData check
    // https://javascript.info/formdata
    signupForm.addEventListener('formdata', (e) => {
        const formData = e.formData;
        //no need change document.getElementById().value = "";
        // formData.set('field1', 'foo');
        // formData.set('field2', 'bar');
        //updated formData
        console.log(formData)
    });



    // =============================Username Validation ========================

    let usernameInput = document.getElementById('username')
    let checkUsernameSuccess = document.getElementById('check-username-success')
    let checkUsernameError = document.getElementById('check-username-error')

    // Reset username validation error message
    const resetUsernameCheckErrors = () => {
        // usernameInput.classList.remove("error");
        checkUsernameSuccess.classList.add("hidden");
        checkUsernameError.classList.add("hidden");
        checkUsernameError.innerHTML = "";
        checkUsernameSuccess.innerHTML = "";
        checkUsernameSuccess.classList.remove("flex");
        checkUsernameError.classList.remove("flex");
    };

    if (usernameInput !== null) {    
        usernameInput.addEventListener('focusout', ValidateUsernameUnique);
        // on keyup / change: reset
        usernameInput.addEventListener('change', resetUsernameCheckErrors);
        usernameInput.addEventListener('keyup', resetUsernameCheckErrors);    
    }


    async function ValidateUsernameUnique() {
        // username will be validated with focus out event, to call the server 
        // for uniqueness
        let usernameInput = document.getElementById('username')
        const username = (usernameInput.value).trim();

        if (username == "") {
            let msg = "username is empty"
            console.log(msg)
            showUsernameError(msg)
            return false
        }

        // If contains space or greater than 20 or less than 3
        if ((username.length < 3)) {
            //if username < 3 show error notice
            let msg = "username should not be less than three characters"
            console.log(msg)
            showUsernameError(msg)
            return false
        }

        if (hasWhiteSpace(username) || containsWhiteSpace(username)) {
            //if username contains spaces show error notice
            let msg = "username should not contain space"
            showUsernameError(msg)
            return false
        }

        let respObj = await isUniqueUsername(username)

        // else, call server for check
        if (!respObj.unique) {
            // let msg = "Username is already taken. Try another one or scroll up and tap 'click here to login' above if you already have an account"

            // Set recommended value
            usernameInput.value = respObj.recommended
            // Scroll to view
            usernameInput.scrollIntoView({ behavior: 'smooth' });
            usernameInput.setAttribute('tabindex', '-1'); // ensure it can receive focus
            usernameInput.focus({ preventScroll: true });
            /*
            let suggestedUserName = username + GenerateThreeNonZeroRandoms()
            // Get check-username-error and display the following:
            msg = 'Try <strong>' +suggestedUserName+ '</strong> because ' +username+ 'has already been used by someone. you can try a different nickname. If you already have a Pinkbluers Method account, then or scroll up and tap on "tap here to login"'

            console.log(msg) */
            // showUsernameError(msg)

            // Send tracking event
            SubmitTrackedAuthEventInfo("did_not_pass_validation_username_not_unique: " + username + ", suggested: " + respObj.recommended, "signup")

            return false
        }

        return true
    }

    function showUsernameError(msg){
        console.log(msg)
        resetUsernameCheckErrors()
        checkUsernameError.innerHTML = msg
        // checkUsernameError.classList.add("flex")
        checkUsernameError.classList.remove("hidden")
        return false
    }
    function showUsernameSuccess(msg){
        console.log(msg)
        resetUsernameCheckErrors()
        checkUsernameSuccess.innerHTML = msg
        // checkUsernameSuccess.classList.add("flex")
        checkUsernameSuccess.classList.remove("hidden")
        return false
    }



    // =============================Emails Validation Starts========================

    let emailInput = document.getElementById('email')
    let checkEmailSuccess = document.getElementById('check-email-success')
    let checkEmailError = document.getElementById('check-email-error')

    // Reset email validation error message
    const resetEmailCheckErrors = () => {
        // usernameInput.classList.remove("error");
        checkEmailSuccess.classList.add("hidden");
        checkEmailError.classList.add("hidden");
        checkEmailError.innerHTML = "";
        checkEmailSuccess.innerHTML = "";
        checkEmailSuccess.classList.remove("flex");
        checkEmailError.classList.remove("flex");
    };

    if (emailInput !== null) {    
        emailInput.addEventListener('focusout', ValidateEmailUnique);
        // on keyup / change: reset
        emailInput.addEventListener('change', resetEmailCheckErrors);
        emailInput.addEventListener('keyup', resetEmailCheckErrors);    
    }


    async function ValidateEmailUnique() {
        // email will be validated with focus out event
        const email = document.getElementById('email').value;

        let isValidEmail = true

        // no email to validate, return true
        if (!email.trim()) {
            let msg = "no email entered"
            console.log(msg)
            isValidEmail = true
            return isValidEmail
        }

        // else, there is email, validate regex
        let emailRgx = /^[a-zA-Z0-9. _-]+@[a-zA-Z0-9. -]+\.[a-zA-Z]{2,4}$/;
        if (!email.match(emailRgx)){
            let msg = "email should contain @ and a domain e.g .com, .net, .org etc"
            console.log(msg)
            showEmailError(msg)
            isValidEmail = false
            return isValidEmail
        }

        if (hasWhiteSpace(email) || containsWhiteSpace(email)) {
            let msg = "email should not contain any spaces"
            console.log(msg)
            showEmailError(msg)
            isValidEmail = false
            return isValidEmail
        }

        let isUniqueCheck = await isUniqueEmail(email)

        // else, call server for check
        if (!isUniqueCheck) {
            let msg = "An account already exists with this email. Try another one or tap 'click here to login' above if you already have an account"
            showEmailError(msg)
            return false
        } else {
            showEmailSuccess("great! valid email format")
        }

        return isValidEmail
    }

    function showEmailError(msg){
        console.log(msg)
        resetEmailCheckErrors()
        checkEmailError.innerHTML = msg
        checkEmailError.classList.add("flex")
        checkEmailError.classList.remove("hidden")
        return false
    }
    function showEmailSuccess(msg){
        console.log(msg)
        resetEmailCheckErrors()
        checkEmailSuccess.innerHTML = msg
        checkEmailSuccess.classList.add("flex")
        checkEmailSuccess.classList.remove("hidden")
        return false
    }


    // =================Password Validation Starts=============================


    let passwordInput = document.getElementById('password')
    let cPasswordInput = document.getElementById('c-password')
    let checkPasswordSuccess = document.getElementById('check-password-success')
    let checkPasswordError = document.getElementById('check-password-error')

    // Reset password validation error message
    const resetPasswordCheckNotices = () => {
        // usernameInput.classList.remove("error");
        checkPasswordSuccess.classList.add("hidden");
        checkPasswordError.classList.add("hidden");
        checkPasswordError.innerHTML = "";
        checkPasswordSuccess.innerHTML = "";
        checkPasswordSuccess.classList.remove("flex");
        checkPasswordError.classList.remove("flex");
    };


    if (cPasswordInput !== null) {    
        cPasswordInput.addEventListener('focusout', ValidatePasswords);
        // on keyup / change: reset
        cPasswordInput.addEventListener('change', resetPasswordCheckNotices);
        cPasswordInput.addEventListener('keyup', resetPasswordCheckNotices);    
    }


    if (passwordInput !== null) {    
        passwordInput.addEventListener('focusout', ValidatePasswords);
        // on keyup / change: reset
        passwordInput.addEventListener('change', resetPasswordCheckNotices);
        passwordInput.addEventListener('keyup', resetPasswordCheckNotices);    
    }

    
    function ValidatePasswords() {
        let isValidPassword = true

        // Retrieve other form field values for validation
        const password = document.getElementById('password').value;

        // Validate Simple Password
        if ( signupType == "simple" ) {
            return password != ""
        }

        const c_password = document.getElementById('c-password').value;
            
        // If c_password != password, return false. Show error notice
        if(password == "" || c_password == "" ){
            isValidPassword = false
            let msg = "ensure you fill both password inputs with the same password"
            console.log(msg)
            if (validatingPasswordOnFormSubmit) {
                showPasswordError(msg)
            }   
            return false
        }

        // If c_password != password, return false. Show error notice
        if(password !== c_password && (password != "" && c_password != "" )){
            isValidPassword = false
            let msg = "both passwords do not match. click or tab on the eye icon to reveal the passwords you typed and ensure they both match"
            console.log(msg)
            showPasswordError(msg)
            return false
        }

            // If password length not => 6 return false, show error
        if (password.length < 6){
            isValidPassword = false
            let msg = "password is less than 6 characters"
            console.log(msg)
            showPasswordError(msg)
            return false
        }

        // if password doesn't contain number or uppercase, return false, show error
        // one digit, one lowercase, one uppercase, and no minimum length
        // let passwordRgx = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*$/ 
        // one digit, one lowercase, one uppercase, at least 6
        let passwLengthRgx = /^.{6,}$/; // Already checked

        let passwLowercaseRgx = /^(?=.*[a-z]).*$/
        if (!password.match(passwLowercaseRgx)){
            isValidPassword = false
            let msg = "Your password should contain at least one Lowercase(small letter)"
            console.log(msg)
            showPasswordError(msg)
            return false
        }

        let passwUpperRgx = /^(?=.*[A-Z]).*$/
        if (!password.match(passwUpperRgx)){
            isValidPassword = false
            let msg = "Your password should contain at least one Uppercase(capital letter)"
            console.log(msg)
            showPasswordError(msg)
            return false
        }

        let passwNumberRgx = /^(?=.*\d).*$/;
        if (!password.match(passwNumberRgx)){
            isValidPassword = false
            let msg = "Your password should contain at least one number"
            console.log(msg)
            showPasswordError(msg)
            return false
        }

        let passwRgx = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}$/;
        if (!password.match(passwRgx)){
            isValidPassword = false
            let msg = "In addition to lowercase (small letters), your password should contain at least one uppercase(capital letter) and at least one number"
            console.log(msg)
            showPasswordError(msg)
            return false
        }

        showPasswordSuccess("great! both passwords match")
        // setTimeout(function(){
        //     resetPasswordCheckNotices()
        // },600)
    
        return isValidPassword
    }

    function showPasswordError(msg){
        console.log(msg)
        resetPasswordCheckNotices()
        checkPasswordError.innerHTML = msg
        checkPasswordError.classList.add("flex")
        checkPasswordError.classList.remove("hidden")
        return false
    }
    function showPasswordSuccess(msg){
        console.log(msg)
        resetPasswordCheckNotices()
        checkPasswordSuccess.innerHTML = msg
        checkPasswordSuccess.classList.add("flex")
        checkPasswordSuccess.classList.remove("hidden")
        return false
    }

    // =====================Password Validation Ends===============================

    if (desiredGenderElem !== null) {    
        desiredGenderElem.addEventListener('focusout', function(){
            desiredGender = desiredGenderElem.value
            resetSignUpError()
        });

        // on keyup / change: reset
        desiredGenderElem.addEventListener('keyup', resetSignUpError); 

        desiredGenderElem.addEventListener('change', function(){
            // Reset any signup maybe error due to not selecting desired gender
            resetSignUpError()

            desiredGender = desiredGenderElem.value

            SubmitTrackedAuthEventInfo("desired_gender_selected: " + desiredGender, "signup")
        });
        
    }


    async function SubmitTrackedLeadEvent(eventDescription, page) {

        let targetInfo = eventDescription;

        // let currentPage = page;
        let currentPage = GetSlugAndParamsFromNext().srcPage
        if (currentPage == null) {
            currentPage = page
        }

        // Set Event Handle
        let eventHandle = "auth event from: "
       
        // Already tracked, send the update event to backend
        if (window.TrackedLeadEvent) {
            eventHandle = "lead update event from: "
            console.log("lead event already tracked sending lead update")
            
        }  else if ((window.TEmailAddress != "" || window.TPhoneNumber != "")) {
            window.TrackedLeadEvent = true
            eventHandle = "lead event from: "
            console.log("lead event condition met, sending lead track")
        }

        return fetch('/page/trackleads/?event='+targetInfo, {
            method: 'POST',
            body: JSON.stringify({
                event: eventHandle +" "+ currentPage +" page", 
                page: currentPage, 
                target: targetInfo,
                country: SelectedPhoneCountry,
                name: TFullName,
                phone: PhoneInputValue,
                email: TEmailAddress,
            }),
            mode: 'cors',
            // redirect:'manual',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            },
        })
        .then(response => {
            // If server error occurred, throw error
            if (response.status >= 500) {
            throw new Error('Server error');
            }
            return response.json();
        }) .catch(error => {
            // Handle any errors that occur during form submission
            console.error(error);
            return error;
        });
    }

    async function SubmitTrackedAuthEventInfo(eventDescription, page) {

        let targetInfo = eventDescription;

        let currentPage = page;

        return fetch('/page/trackevents/?event='+targetInfo, {
            method: 'POST',
            body: JSON.stringify({page: "auth event from: " + currentPage +" page", target: targetInfo}),
            mode: 'cors',
            // redirect:'manual',
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            },
        })
        .then(response => {
            // If server error occurred, throw error
            if (response.status >= 500) {
            throw new Error('Server error');
            }
            return response.json();
        }) .catch(error => {
            // Handle any errors that occur during form submission
            console.error(error);
            return error;
        });
    }
    

    function validateDesiredGenderInput() {
        // Validate Desired gender input
        if (desiredGenderElem !== null){
            let selectedDesiredGender = desiredGenderElem.value;
            if (selectedDesiredGender == "") {
                // Display Signup Error
                let msg = "You haven't selected the gender you would like to conceive. Scroll to the top and choose"
                console.log("desired gender not selected")
                ShowSignUpError(msg)

                // Send tracking event
                SubmitTrackedAuthEventInfo("has_not_passed_validation_desired_gender_not_selected: ", "signup")

                return false
            }
            desiredGender = selectedDesiredGender
            return true
        }
        // if no desired gender element, return true
        return true;
    }

    if (genderElem !== null) {    
        genderElem.addEventListener('focusout', resetSignUpError);
        // on keyup / change: reset
        genderElem.addEventListener('change', resetSignUpError);
        genderElem.addEventListener('keyup', resetSignUpError);    
    }

    function validateGenderInput() {
        // Validate User gender input (Optional)
        if (genderElem !== null){
            let gender = genderElem.value;
            if (gender == ""){
                genderElem.value = "female"
                // Send tracking event
                SubmitTrackedAuthEventInfo("has_not_selected_gender_category_female_assumed: ", "signup")
                return true;
                
                // Display Errors
                /*let msg = 'You haven\'t selected a category'
                console.log("User's Gender not selected")
                ShowSignUpError(msg)
                return false; */
            }
            return true
        }
        // if no gender element, return true
        return true;
    }

    function validatePartnersAccesCode() {
        // Validate Access Code input
        if (!isPartnersSignup) {
            return true
        }

        if (accessCodeElem !== null){
            let accessCode = accessCodeElem.value;
            if (accessCode == ""){
                // Display Errors
                let msg = 'To sign up as a partner, you need to have a valid access code'
                console.log("Access code not provided")
                ShowSignUpError(msg)
                return false;
            }
            return true
        }
        // if no access code element, return true
        return true;
    }

    if (secretCodeElem !== null) {    
        secretCodeElem.addEventListener('focusout', resetSignUpError);
        // on keyup / change: reset
        secretCodeElem.addEventListener('change', resetSignUpError);
        secretCodeElem.addEventListener('keyup', resetSignUpError);    
    }

    function validateSecretCodeInput() {
        // Validate Secret Code Input for Advanced Signup
        if ( signupType == "simple" ) {
            // Simple signup form doesn't have secret code field
            return true
        }

        if (secretCodeElem !== null){
            let secretCode = secretCodeElem.value;

            if (secretCode.length < 4 ) {
                // Display Signup Error
                let msg = "length of secret code should not be less than 4"
                ShowSignUpError(msg)
                return false;
            }
            return true;
        }
        // if no gender element, return true
        return true;
    }

    if (currencyElem !== null) {    
        currencyElem.addEventListener('focusout', resetSignUpError);
        // on keyup / change: reset
        currencyElem.addEventListener('change', resetSignUpError);
        currencyElem.addEventListener('keyup', resetSignUpError);    
    }
    function validateCurrencySelectInput() {
        // Validate Secret Code Input for Advanced Signup
        if ( signupType == "simple" ) {
            // Simple signup form doesn't have secret code field
            return true
        }

        if (currencyElem !== null){
            let currency = currencyElem.value;

            if (currency == "" ) {
                // Display Signup Error
                let msg = "You haven't selected a currency"
                ShowSignUpError(msg)
                return false;
            }
            return true;
        }
        // if no gender element, return true
        return true;
    }

    function hasWhiteSpace(s) {
        return /\s/g.test(s); // Looks like some divices don't support this test, so combine it
    }

    function containsWhiteSpace(s) {
        return s.indexOf(' ') >= 0; // Logic is tested correct (do not remove =)
    }

    // https://www.squash.io/how-to-get-query-string-values-in-javascript/

    // Both using URLSearchParams and manually parsing with getQueryParams work
    /*    // Assuming the URL is https://example.com/?name=John&age=30

        const urlParams = new URLSearchParams(window.location.search);
        const name = urlParams.get('name');
        const age = urlParams.get('age');
    
        console.log(name); // Output: John
        console.log(age); // Output: 30

        // Assuming the URL is https://example.com/?name=John&age=30


        const queryParams = getQueryParams(window.location.href);    
        console.log(queryParams.name); // Output: John
        console.log(queryParams.age); // Output: 30
    */
    function getQueryParams(url) {
        const queryString = url.split('?')[1];
        const params = {};
    
        if (queryString) {
        queryString.split('&').forEach((param) => {
            const [key, value] = param.split('=');
            params[key] = decodeURIComponent(value);
        });
        }
    
        return params;
    }

    function ShowSignUpSuccess(msg) {
        let checkSignupSuccess = document.getElementById('check-signup-success')
        let checkSignupError = document.getElementById('check-signup-error')

        if (checkSignupError !== null ){
            checkSignupError.classList.add("hidden")
            checkSignupError.classList.remove("flex")
        }

        if (checkSignupSuccess !== null ){
            checkSignupSuccess.classList.add("flex")
            checkSignupSuccess.classList.remove("hidden")
        }

        console.log(msg)
        checkSignupSuccess.innerHTML = msg
        
    }
    function ShowSignUpError(msg) {
        let checkSignupSuccess = document.getElementById('check-signup-success')
        let checkSignupError = document.getElementById('check-signup-error')

        if (checkSignupError !== null ){
            checkSignupError.classList.add("flex")
            checkSignupError.classList.remove("hidden")
        }

        if (checkSignupSuccess !== null ){
            checkSignupSuccess.classList.add("hidden")
            checkSignupSuccess.classList.remove("flex")
        }

        console.log(msg)
        checkSignupError.innerHTML = msg
        
    }

    function resetSignUpError() {
        let checkSignupError = document.getElementById('check-signup-error')

        if (checkSignupError !== null ){
            checkSignupError.classList.add("hidden")
            checkSignupError.classList.remove("flex")
            checkSignupError.innerHTML = "";
        }
    }


    async function isUniqueEmail(email) {
        // Code to submit the email to the server
        // Here, we'll use the fetch() function to POST the data to an API endpoint
        let isUnique = false
        let emailCheck = fetch('/unique/email', {
            method: 'POST',
            // body: JSON.stringify({ email, password}),
            body: JSON.stringify({ email}),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        })
        .then(response => response.json())
        .then(data => {
            // Handle the response from the server
            console.log(data);
            if (!data.error) {
                isUnique = true; 
                showEmailSuccess(data.message)            
            } else {
                isUnique = false;
                showEmailError(data.message)
                // Show error notice. Email already taken
            }

            return isUnique // Using return in a promise
        })
        .catch(error => {
            // Handle any errors that occur during form submission        
            console.error(error);
            showEmailError(error)
        });

        let result = await emailCheck
        return result
    }

    async function isUniqueUsername(username) {
        // Code to submit the username to the server
        // Here, we'll use the fetch() function to POST the data to an API endpoint
        let isUnique = false
        let usernameCheck = fetch('/unique/username', {
            method: 'POST',
            // body: JSON.stringify({ username, password}),
            body: JSON.stringify({ username}),
            headers: {
                'Content-type': 'application/json; charset=UTF-8',
            },
        })
        .then(response => response.json())
        .then(data => {
            // Handle the response from the server
            console.log(data);
            if (!data.error) {
                isUnique = true; 
                showUsernameSuccess(data.message)            
            } else {
                isUnique = false; 
                showUsernameError(data.message)
                // Show error notice. Username already taken
            }

            return {"unique": isUnique, "recommended": data.recommended} // Using return in a promise
        })
        .catch(error => {
            // Handle any errors that occur during form submission
            console.error(error);
            showUsernameError(error)
        });

        let result = await usernameCheck

        console.log("returned check for username:", result)
        return result
    }

    // https://javascript.info/formdata
    // https://rapidapi.com/guides/error-handling-fetch
    // https://stackoverflow.com/questions/39735496/redirect-after-a-fetch-post-call
    async function SubmitSignUpForm() {

        // Disable Signup Button
        let signupButton = document.getElementById("signup-button")
        signupButton.disabled = true;

        let signupFormData = new FormData(signupForm)
        // Add the country that was selected
        signupFormData.append("phone_country", "");
        if (PhoneInputValue !== ""){
            signupFormData.append("phone_country", SelectedPhoneCountry);
        }

        // Add the desired gender that was selected
        signupFormData.append("desired_gender", desiredGender);

        console.log("signup form data: ", signupFormData)


        // console.log("The SignupFormAction Url is: ", signupFormActionUrl)

        let signUpResponse = fetch(signupFormActionUrl, {
            "method": "POST",
            body: signupFormData,
            "headers": {
                // "x-rapidapi-key": "invalid-key",
                // "x-rapidapi-host": "open-weather13.p.rapidapi.com"
            },
        })
        .then(response => {

            signupButton.disabled = false;

            if (response.type == "opaqueredirect"){  
                // ensure to set redirect:'manual', in fetch's config to use this option
                // default is follow redirect which will create two requests
                // To make sure the fetch is with redirect response return. 
                // response.url here is still that of the post action. Only use if you want
                // to set your redirect url by yourself 
                //   window.location.replace(response.url); // create one and only one request
                //   return;
            }
            // There is also response.status
            // if (!(response.ok || response.status >= 500  || response.redirected)) {
            if (response.status >= 500) {
                throw new Error('Server error');
            }
            // Follow redirects if redirected from server
            if (response.redirected) {
                // Since backend creates session and redirects to page, then 
                window.location.href = response.url;
                return true
            }
            return response.json();
        })
        .then(data => {
            // Do something with the data
            console.log(data.message) 
            if (!data.error) {
                ShowSignUpSuccess(data.message)

                setTimeout(function() {
                    // redirect to dashboard
                    if (data.hasOwnProperty('data')) {
                        window.location.href = data.data.next;
                    }
                }, 2000)

                return true
            } else {
                ShowSignUpError(data.message)
                return false
            } 
        })
        .catch(error => {   
            let msg = "Error occurred during sign up: " + error 
            signupButton.disabled = false;
            ShowSignUpError(msg)            
            // console.error(msg);
        });

        let signUpSuccess = await signUpResponse
        return signUpSuccess
    }

}

/*
// Check if function exists before defining another one
// https://stackoverflow.com/a/11035071/16649244
if ( typeof yourFunctionName == 'undefined' ) {
    var yourFunctionName = function( params ) {
      // your code here
    };
}
*/












